<template>
  <v-content class="esh-theme">
    <v-toolbar height="22">
      <v-toolbar-items>
        <v-btn
          v-if="home"
          :to="{ name: home.name }">
          <v-icon>home</v-icon>
        </v-btn>
        <v-btn
          v-for="(item, idx) in items"
          :key="idx"
          :to="{ name: item.name }"
        >{{ item.meta.label || '' }}</v-btn>
        <v-btn @click="confirmExit">Выход</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-container fluid>
      <router-view></router-view>
    </v-container>
    <ConfirmModal
            :dialog.sync="exitConfirmation"
            title="Внимание"
            contentClass="esh-theme adminModal"
            confirmBtnText="Выйти"
            @confirm="exit"
    >
      <template #body>
        <v-row >
          <v-col>
            Вы действительно хотите выйти?
          </v-col>
        </v-row>
      </template>
    </ConfirmModal>
  </v-content>
</template>

<script>
import Routes from '@/router/superadmin'
import TokenService from "@/services/tokenService";
import router from "@/router";
import ConfirmModal from "@/components/common/modals/ConfirmModal";

export default {
  name: 'SuperAdminIndex',
  components: {
    ConfirmModal
  },
  data() {
    return {
      exitConfirmation: false
    }
  },
  computed: {
    items() {
      return Routes.children.filter(item => item.path !== '')
    },
    home() {
      return Routes.children.find(item => item.path === '')
    }
  },
  methods: {
    confirmExit() {
      this.exitConfirmation = true
    },
    exit() {
      TokenService.clearTokens()
      router.push({
        name: 'auth'
      })
    }
  }
}
</script>
